import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import '../scss/App.scss';

import Header from './lib/Header';
import Footer from './lib/Footer';
import ScrollToTop from './lib/ScrollToTop';

import Home from './routes/Home';
import DistrictDetail from './routes/DistrictDetail';
import QuestionDetail from './routes/QuestionDetail';
import RaceDetail from './routes/RaceDetail';
import RacesToWatch from './routes/RacesToWatch';

import Utils from '../../utils';

const utils = Utils({});

export default class App extends Component {
  render() {
    let { districts, races, questions } = this.props;
    const racesToWatch = [
      races.mayor,
      races.comptroller,
      races['public-advocate'],
    ];

    return (
      <div className="App">
        <Header />
        <Router basename={ROOT_URL}>
          <ScrollToTop pym={utils.pym}>
            <div>
            
              <Route exact path="/" render={router => <Home router={router} districts={districts} />} />

              <Route path="/districts/:district" render={router => <DistrictDetail router={router} races={races} ballotQuestions={questions} /> }/>

              <Route path="/races/:race" render={router => <RaceDetail router={router} allRaces={races} />} />
              
              <Route path="/questions/:question" render={router => <QuestionDetail router={router} questions={questions} />} />

              <Route path="/citywide-races" render={router => <RacesToWatch races={racesToWatch} router={router} />} />
              
            </div>
          </ScrollToTop>
        </Router>
        <Footer />
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./app/src/js/App.js